import React from 'react';
import { CoauthorSummary as BaseCoauthorSummary } from '@workboard/ui-summary';
import { ThemeProvider, ScopedCssBaseline, styled } from '@mui/material';
import { GlobalStyle, theme } from './theme/theme';

const StyledCssBaseline = styled(ScopedCssBaseline)({
  'body #coauthor-summary-component &': {
    // workaround for conflicts
    '& div.MuiInputBase-multiline': {
      border: 'none',
      padding: '8px 0px 16px',
    },
    '& form button div': {
      height: '100%',
    },
  },
});

function CoauthorSummary (props: any) {
  return (
    <StyledCssBaseline>
      <ThemeProvider theme={theme}>
        <GlobalStyle />
        <BaseCoauthorSummary  {...props} />
      </ThemeProvider>
    </StyledCssBaseline>
  );
}

export default CoauthorSummary;
